import React from "react";
import { CheckCircle2, Lock } from "lucide-react";

const Item = ({ ref_, label, withheld }) => (
    <li className="flex items-start gap-3 py-2.5 border-b last:border-b-0 border-slate-200/70">
        {withheld ? (
            <Lock className="h-4 w-4 mt-0.5 text-red-600 shrink-0" />
        ) : (
            <CheckCircle2 className="h-4 w-4 mt-0.5 text-emerald-600 shrink-0" />
        )}
        <div className="flex-1">
            <div className={`text-sm ${withheld ? "text-red-900" : "text-emerald-900"}`}>
                {label}
            </div>
            <div className="font-mono text-[11px] text-slate-500 mt-0.5">{ref_}</div>
        </div>
    </li>
);

export const EvidenceBoundary = ({ shared = [], withheld = [] }) => (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div
            data-testid="evidence-shared-panel"
            className="border border-emerald-200 bg-emerald-50/60 rounded-sm p-6 hover-lift"
        >
            <div className="flex items-center justify-between mb-4">
                <div>
                    <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-emerald-700">
                        Available to prompt route
                    </div>
                    <div className="mt-1 font-heading text-xl font-semibold text-emerald-900">
                        Shared evidence · {shared.length}
                    </div>
                </div>
                <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-emerald-700">
                    metadata + refs only
                </div>
            </div>
            <ul className="divide-y divide-emerald-200/70">
                {shared.map((e) => (
                    <Item key={e.ref} ref_={e.ref} label={e.label} />
                ))}
            </ul>
        </div>

        <div
            data-testid="evidence-withheld-panel"
            className="border border-red-200 rounded-sm p-6 withheld-stripes bg-red-50/40 hover-lift"
        >
            <div className="flex items-center justify-between mb-4">
                <div>
                    <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-red-700">
                        Withheld / internal only
                    </div>
                    <div className="mt-1 font-heading text-xl font-semibold text-red-900">
                        Withheld evidence · {withheld.length}
                    </div>
                </div>
                <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-red-700">
                    stays at source
                </div>
            </div>
            <ul className="divide-y divide-red-200/70">
                {withheld.map((e) => (
                    <Item key={e.ref} ref_={e.ref} label={e.label} withheld />
                ))}
            </ul>
        </div>
    </div>
);

export default EvidenceBoundary;
